import nomes from './situacoes.nomes';
import cores from './situacoes.cores';

export default
    [
    {
        nome: nomes.Agendado,
        situacao: nomes.Agendado,
        condicao: e => !e.profissionais,
        cores: cores[nomes.Agendado]
    },
    {
        nome: nomes.AgendadoProfissional,
        situacao: nomes.Agendado,
        condicao: e => e.profissionais && !e.profissionais.responsavel.preferencial,
        cores: cores[nomes.AgendadoProfissional]
    },
    {
        nome: nomes.AgendadoProfissionalPreferencial,
        situacao: nomes.Agendado,
        condicao: e => e.profissionais && e.profissionais.responsavel.preferencial,
        cores: cores[nomes.AgendadoProfissionalPreferencial]
    },
    {
        nome: nomes.Confirmado,
        situacao: nomes.Confirmado,
        condicao: () => true,
        cores: cores[nomes.Confirmado]
    },
    {
        nome: nomes.Faltou,
        situacao: nomes.Faltou,
        condicao: () => true,
        cores: cores[nomes.Faltou]
    },
    {
        nome: nomes.Presente,
        situacao: nomes.Presente,
        condicao: () => true,
        cores: cores[nomes.Presente]
    },
    {
        nome: nomes.Bloqueio,
        situacao: nomes.Bloqueio,
        condicao: () => true,
        cores: cores[nomes.Bloqueio]
    },
    {
        nome: nomes.ExecutadoPreVenda,
        situacao: nomes.Executado,
        condicao: e => (e.situacao == 'Executado' && (e.servicoAvulso && e.servico.transacaoMovimento == 0) && !e.servico.servicoAvaliacao),
        cores: cores[nomes.ExecutadoPreVenda]
    },
    {
        nome: nomes.ExecutadoPago,
        situacao: nomes.Executado,
        condicao: e => (e.situacao == 'Executado' && !e.servicoAvulso || (e.servicoAvulso && e.servico.transacaoMovimento != 0) || e.servico.servicoAvaliacao),
        cores: cores[nomes.ExecutadoPago]
    }
]
